import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Footer from 'layouts/Main/components/Footer';
import { Typography } from '@mui/material';

import Container from 'components/Container';
import {
  Contact,
  Gallery,
  Hero,
  Partners,
  Story,
  Team,
  WhoWeAre,
  Application,
} from './components';

import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-W1G8LXHX5C']
    })
  ]
})
const analyticsa = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-X34JYK01Q0']
    })
  ]
})
analytics.page()
analyticsa.page()



const About = () => {
  return (

    <>
    <div style={{ height: 40, backgroundColor: '#377dff', padding: '10px' }}>
      <Typography
      style={{ float: 'left' }}
      variant={'subtitle2'}
      color={'white'}
    >NPS YPR</Typography>
      <a style={{ float: 'right' }} href="/online-registration-email-login" >
        <img 
        height={20}
        width={20}
        color={'white'}
        src='https://cdn-icons-png.flaticon.com/512/25/25376.png'/>
      </a>
    </div>
   
      <Container>
      <Application />
      </Container>
      <Container maxWidth={0.9} marginTop={-6}>
        <Footer />
      </Container>
    </>
   
    
  );
};

export default About;
